import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-public-footer',
  templateUrl: './public-footer.component.html',
  styleUrls: ['./public-footer.component.css']
})
export class PublicFooterComponent implements OnInit {
  ano: number;
  supportText: string;
  phoneNumber: string;
  frequentlyAskQuestions: string;

  constructor() { 
    this.ano = new Date().getFullYear();
    this.supportText = 'Support desk';
    this.phoneNumber = '800 800 8000';
    this.frequentlyAskQuestions = 'Frequently asked questions';
  }

  ngOnInit() {
  }

}
